
$(function() {
   
    if ($('.price-calculator.companies').length > 0) {
        
        var setupCalculator = function() {
            var users = $('.teamMembers-input').val();
            var timeSpent = $('.calculator-btn.timeSpent').not('.inverse').attr('data-timeSpent');
            var costs = $('.costs-input').val();

            showPrice(users, timeSpent, costs);

            $('.teamMembers-input').change(function() {
                users = $(this).val();
                showPrice(users, timeSpent, costs);
            });


            $('.calculator-btn.timeSpent').click(function() {            
                
                $('.timeSpent').addClass('inverse');
                $(this).removeClass('inverse');

                timeSpent = $(this).attr('data-timeSpent');
                showPrice(users, timeSpent, costs);
            });
            

            $('.costs-input').change(function() {
                costs = $(this).val();
                showPrice(users, timeSpent, costs);
            });

        }

        var showPrice = function(users, timeSpent, costs) {
            hoursSavedPerUser = parseFloat(timeSpent) / 2 * 20;
            moneySaved = hoursSavedPerUser * users * costs;
          
            $('.save-value').text(formatCurrency(moneySaved));
            $('.hours-value').text(hoursSavedPerUser);
        }



        var formatCurrency = function($amount) {
            return round($amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " " + $('.price-calculator').attr('data-currency');
        }

        
        setupCalculator();
    }    
})
